import {
    Autocomplete,
    FormControl,
    FormControlLabel,
    Grid,
    InputAdornment,
    Paper,
    Radio,
    RadioGroup,
    Skeleton,
    TextField,
    Typography,
} from '@mui/material';
import InputForm from '../../commun/input-form';
import { ReferenceDto } from '../../../services/dtos/reference.dto';
import React, { ChangeEvent } from 'react';
import SelectForm from '../../commun/select-form';
import { AddressGouvFeaturesPropertiesFormDto } from '../../../services/dtos/form/address-gouv-features-properties-form.dto';
import { parseHouseNumber } from '../../../utils/address-parser.utils';
import { useFormikContext } from 'formik';

/**
 * Partie du formulaire de déménagement : infos départ de la personne entrant
 * @constructor
 */
export default function MoveHouseOtherInfosForm(props: {
    //Handler lors du changement de pays
    handleChangeCountry: (e: React.SyntheticEvent, v: ReferenceDto | null) => void;
    //Handler lors du changement de pays entrant
    handleChangeCountryIncomingPerson: (e: React.SyntheticEvent, v: ReferenceDto | null) => void;
    //Liste des pays
    countriesSelection: ReferenceDto[];
    //Handler changement de valeur
    handleChangeIncomingPerson: (e: ChangeEvent<HTMLInputElement>, value: string) => void;
    //value connait ou non l'entrant
    incomingPerson: string;
    //Valeur est personne moral
    isMoral: boolean;
    //Handler lors du changement d'interlocuteur
    handleChangeInterlocutor: (interlocutor: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
    //Liste interlocuteurs
    interlocutorsSelection: { value: string; label: string }[];
    //Liste civilités
    civilities: ReferenceDto[];
    //Pays sélectionné pour la personne entrante
    selectedIncomingPersonCountry?: ReferenceDto;
    //Handle pour la recherche d'adresse de la personne entrante
    handleSearchAddressIncoming?: (event: object, value: string, reason: string) => void;
    //Liste des adresses gouvernementales pour la personne entrante
    addressesGouvIncoming?: AddressGouvFeaturesPropertiesFormDto[];
    //Handle pour la sélection d'une adresse de la personne entrante
    handleSelectAddressIncoming?: (address: AddressGouvFeaturesPropertiesFormDto | null) => void;
}) {
    const { setFieldValue } = useFormikContext();
    return (
        // fragement
        <>
            {/*grid*/}
            <Grid item xs={12}>
                {/*Paper*/}
                <Paper>
                    {/*Connait l'entrant*/}
                    {/*si oui on affiche les infos*/}
                    {/*si non on n'affiche rien de plus*/}
                    <Typography variant="h5">
                        Connaissez-vous la personne qui va occuper votre logement actuel ?
                    </Typography>
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="radio-buttons-group"
                            name="radio-buttons-group"
                            value={props.incomingPerson}
                            onChange={props.handleChangeIncomingPerson}
                        >
                            <FormControlLabel value={'Oui'} control={<Radio />} label="Oui" />
                            <FormControlLabel value={'Non'} control={<Radio />} label="Non" />
                        </RadioGroup>
                    </FormControl>

                    {/*Infos de la personne*/}
                    {props.incomingPerson === 'Oui' ? (
                        // grid
                        <Grid container spacing={1} className="blocIncomingPerson">
                            <Grid item xs={12}>
                                {/*coordonnées*/}
                                <Typography variant="h5">Coordonnées l'usager entrant : </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} md={6}>
                                        {/*champ interlocuteur*/}
                                        <SelectForm
                                            required={true}
                                            values={props.interlocutorsSelection}
                                            handleChange={props.handleChangeInterlocutor}
                                            id="interlocutors"
                                            name="entrant.type"
                                            label="Est-ce un/une :"
                                        />
                                    </Grid>
                                    {/*is != PM : champ civilities*/}
                                    {props.isMoral ? (
                                        ''
                                    ) : (
                                        <Grid item xs={12} md={6}>
                                            <SelectForm
                                                required={true}
                                                values={props.civilities}
                                                id="civilities"
                                                name="entrant.civilite"
                                                label="Civilité"
                                            />
                                        </Grid>
                                    )}
                                    {/*name*/}
                                    <Grid item xs={12} md={6}>
                                        <InputForm required id="name" name="entrant.nomUsage" label="Nom" />
                                    </Grid>
                                    {/*is != PM : champ firstname*/}
                                    {/*is != PM : champ brithDate*/}
                                    {/*is != PM : champ lieu de naissance*/}
                                    {props.isMoral ? (
                                        ''
                                    ) : (
                                        <>
                                            <Grid item xs={12} md={6}>
                                                <InputForm
                                                    required
                                                    id="firstname"
                                                    name="entrant.prenom"
                                                    label="Prénom"
                                                    autoComplete={'given-name'}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <InputForm
                                                    maxDate={new Date().toISOString().split('T')[0]}
                                                    id="brithDate"
                                                    name="entrant.dateNaissance"
                                                    label="Date de naissance"
                                                    type="date"
                                                    autoComplete={'bday'}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <InputForm
                                                    id="birthPlace"
                                                    name="entrant.lieuNaissance"
                                                    label="Lieu de naissance"
                                                />
                                            </Grid>
                                        </>
                                    )}
                                    {/*champ mobilePhone*/}
                                    {/*Ajout inputProps*/}
                                    <Grid item xs={12} md={6}>
                                        <InputForm
                                            id="mobilePhone"
                                            name="entrant.telPort"
                                            label="Téléphone portable"
                                            type="tel"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">0</InputAdornment>,
                                            }}
                                            autoComplete={'tel-national'}
                                        />
                                    </Grid>
                                    {/*champ telFixe*/}
                                    {/*Ajout inputProps*/}
                                    <Grid item xs={12} md={6}>
                                        <InputForm
                                            id="phone"
                                            name="entrant.telFixe"
                                            label="Téléphone fixe"
                                            type="tel"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">0</InputAdornment>,
                                            }}
                                            autoComplete={'tel-national'}
                                        />
                                    </Grid>
                                    {/*champ mail*/}
                                    <Grid item xs={12} md={6}>
                                        <InputForm id="mailPerso" name="entrant.mail" label="Email" type="email" />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                {/*titre*/}
                                <Typography variant="h5">Adresse de l'usager entrant : </Typography>

                                {/* Ajout rapide d'adresse via API data.gouv pour la personne entrante */}
                                {props.handleSearchAddressIncoming && props.addressesGouvIncoming && (
                                    <Autocomplete
                                        data-testid="autocomplete-address-entrant"
                                        disablePortal
                                        id="quickAddressIncoming"
                                        autoHighlight
                                        options={props.addressesGouvIncoming}
                                        getOptionLabel={option => option.label}
                                        onInputChange={props.handleSearchAddressIncoming}
                                        onChange={(_, value) => {
                                            if (value && setFieldValue) {
                                                // Parser le numéro de rue pour séparer le numéro des bis/ter
                                                const parsedNumber = parseHouseNumber(value.housenumber || '');

                                                // Remplir automatiquement les champs du formulaire de la personne entrante
                                                setFieldValue('entrant.adresse.numeroRue', parsedNumber.numero);
                                                setFieldValue('entrant.adresse.rue', value.street || value.name || '');
                                                setFieldValue('entrant.adresse.ville', value.city || '');
                                                setFieldValue('entrant.adresse.codePostal', value.postcode || '');
                                            }
                                            if (props.handleSelectAddressIncoming) {
                                                props.handleSelectAddressIncoming(value);
                                            }
                                        }}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="Rechercher l'adresse de l'usager entrant (optionnel)"
                                                helperText="Tapez l'adresse pour remplir automatiquement les champs ci-dessous"
                                                sx={{ marginTop: '20px', marginBottom: '20px' }}
                                            />
                                        )}
                                    />
                                )}

                                {/*Début grid*/}
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={2}>
                                        {/*Champ numero de rue*/}
                                        <InputForm
                                            id="entrantNumeroRue"
                                            name="entrant.adresse.numeroRue"
                                            label={'N°'}
                                        ></InputForm>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        {/*Champ complement numero de rue*/}
                                        <InputForm
                                            id="entrantComplementNumeroRue"
                                            name="entrant.adresse.complement.numeroRue"
                                            label={'Bis, Ter, ...'}
                                        ></InputForm>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        {/*Champ nom de rue*/}
                                        <InputForm
                                            id="entrantRue"
                                            name="entrant.adresse.rue"
                                            required
                                            label={'Rue'}
                                        ></InputForm>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        {/*Champ complément de rue*/}
                                        <InputForm
                                            id="entrantComplementRue"
                                            name="entrant.adresse.complement.rue"
                                            label={'Complément de rue'}
                                        ></InputForm>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        {/*Champ entree ou residence...*/}
                                        <InputForm
                                            id="entrantBatiment"
                                            name="entrant.adresse.complement.batiment"
                                            label={'Entrée, résidence...'}
                                        ></InputForm>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        {/*Champ étage*/}
                                        <InputForm
                                            id="entrantEtage"
                                            name="entrant.adresse.complement.etage"
                                            label={'Etage'}
                                        ></InputForm>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        {/*Champ appartement*/}
                                        <InputForm
                                            id="entrantAppartement"
                                            name="entrant.adresse.complement.appartement"
                                            label={'Appartement'}
                                        ></InputForm>
                                    </Grid>
                                    {/*Champ complement d'adresse*/}
                                    <Grid item xs={12} sm={6}>
                                        <InputForm
                                            id="entrantEscalier"
                                            name="entrant.adresse.complement.escalier"
                                            label={'Escalier'}
                                        ></InputForm>
                                    </Grid>
                                    {/*Champ code postal*/}
                                    <Grid item xs={12} sm={4}>
                                        <InputForm
                                            id="entrantCodePostal"
                                            name="entrant.adresse.codePostal"
                                            required
                                            label={'Code postal'}
                                        ></InputForm>
                                    </Grid>
                                    {/*Champ ville*/}
                                    <Grid item xs={12} sm={4}>
                                        <InputForm
                                            id="entrantVille"
                                            name="entrant.adresse.ville"
                                            required
                                            label={'Ville'}
                                        ></InputForm>
                                    </Grid>
                                    {/*Champ complement ville*/}
                                    <Grid item xs={12} sm={4}>
                                        <InputForm
                                            id="entrantComplementVille"
                                            name="entrant.adresse.complement.ville"
                                            label={'Complément ville'}
                                        ></InputForm>
                                    </Grid>
                                    {/*Champ boîte postale*/}
                                    <Grid item xs={12} sm={4}>
                                        <InputForm
                                            id="entrantBoitePostale"
                                            name="entrant.adresse.boitePostale"
                                            label={'Boîte postale'}
                                        ></InputForm>
                                    </Grid>
                                    {/*Champ pays*/}
                                    {props.countriesSelection ? (
                                        <Grid item xs={12} sm={4}>
                                            {/*autoCompete*/}
                                            <Autocomplete
                                                data-testid="autocomplete-entrantPays"
                                                disablePortal
                                                id="entrantPays"
                                                autoHighlight
                                                options={props.countriesSelection}
                                                value={props.selectedIncomingPersonCountry}
                                                onChange={props.handleChangeCountryIncomingPerson}
                                                getOptionLabel={option => option.label}
                                                renderInput={params => (
                                                    // render du champ pays
                                                    <TextField
                                                        {...params}
                                                        name="entrant.adresse.pays"
                                                        label="Pays"
                                                        required
                                                    />
                                                )}
                                            ></Autocomplete>
                                        </Grid>
                                    ) : (
                                        // skeleton en attendant
                                        <Skeleton variant="rectangular" height={100}></Skeleton>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    ) : (
                        // aucun affichage si pas de données
                        ''
                    )}
                </Paper>
            </Grid>
        </>
    );
}
